import styled from "styled-components";
import grain from "./../../assets/images/grainBackground.svg";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* background-color: #f8c933; */
  /* background-image: url(${grain}); */
  /* background-blend-mode: multiply; */
  /* width: 100%; */
  width: 380px;
  position: absolute;
  height: 780px;
  margin-bottom: 60px;
`;

export const CenterAbout = styled.div`
  background-color: #463048;
  width: 380px;
  display: flex;
  color: #171312;
  background-image: url(${grain});
  background-blend-mode: multiply;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* overflow-y: scroll;
  &&::-webkit-scrollbar {
    display: none;
  } */
`;

export const HeaderAbout = styled.div`
  display: flex;
  text-align: center;
  padding-left: 30px;
  padding-right: 30px;
  color: #f8c933;
  font-size: 24px;
  letter-spacing: 1px;
  margin-top: 15px;
  margin-bottom: 15px;
  font-weight: 700;
`;

export const AboutText = styled.div`
  font-size: 13.3px;
  font-weight: 400;
  color: white;
`;

export const InstructionDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  gap: 30px;
  margin-top: 14px;
  margin-bottom: 14px;
`;
export const DivButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 30px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const ButtonImg = styled.img`
  width: 30px;
  height: 30px;
`;
export const OuterDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 380px;
`;
